import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type SetUserEnabledPayload = {
  enabled: boolean;
};

export const setUserEnabled = (
  contactId?: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: SetUserEnabledPayload): Promise<string> => {
      return fetchWithAuth<string>("setUserEnabled", contactId, {
        requestOptions: { method: "post", body: JSON.stringify(payload) },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () =>
      defaultOnMutateSettled([
        ["contact", contactId],
        ["keycloakUserInfo", contactId],
      ]),
  });
};
